export default "__VITE_ASSET__b892c243__"